import React, { useId } from 'react';

export default function MenuCheck({checked, onChange, label, ...props})
{
  const uid = useId();

  return (
    <div className="form-check form-check-inline">
      <input 
        type="checkbox" 
        className="form-check-input" 
        id={`dashboardCheckbox${uid}`}
        onChange={e => onChange(e.target.checked)}
        checked={checked}
      />
      <label style={{ cursor: 'pointer' }} className="form-check-label" htmlFor={`dashboardCheckbox${uid}`}>
        {label}
      </label>
    </div>
  );
}